import type { QuizUiVariant } from './quizKindMapping'
import type { QuizStepSelection } from './types'

export const buildQuizStepSelection = (
  variant: QuizUiVariant,
  questionUid: string,
  value: string | string[]
): QuizStepSelection => {
  switch (variant) {
    case 'choice':
    case 'this_or_that':
      return { question_uid: questionUid, alternative_uid: value as string }
    case 'mosaic':
      return { question_uid: questionUid, alternative_uids: value as string[] }
    case 'sorted':
      return { question_uid: questionUid, answer_text: (value as string[]).join(';') }
    case 'text':
    default:
      return { question_uid: questionUid, answer_text: value as string }
  }
}
